/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
import React, { useRef, useEffect, useState, useMemo } from 'react';
import { Icon } from '@iconify/react';
import bellFill from '@iconify/icons-eva/bell-fill';
import doneAllFill from '@iconify/icons-eva/done-all-fill';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroller';

// material
import {
  Box,
  List,
  Badge,
  Tooltip,
  Divider,
  Typography,
  Modal,
} from '@mui/material';
// components
import NotificationItem from './NotificationItem';
import MenuPopover from './MenuPopover';
import MIconButton from '../MIconButton';
// api
import { updateMsgList } from '../../api/user';
import { setNoticeLoading, getMsgLists  } from '../../redux/slice/user';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
};

export default function NotificationsPopover() {
  // eslint-disable-next-line no-unused-vars

  const dispatch = useDispatch();
  const { t } = useTranslation('main');
  const { notificationList, noticeLoading, access_token } = useSelector(
    (state) => state.user
  );
  const { info } = useSelector((state) => state.main);
  const { rows, total } = notificationList;
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);

  const [list, setList] = useState([]);

  // 判断是否还有数据
  const hasMore = useMemo(
    () => list.length < total && !noticeLoading,
    [total, list, noticeLoading]
  );
  useEffect(() => {
    if (!list?.length) {
      setList(rows);
    } else if (hasMore) {
      // 去除重复的通知项
      const findeList = [];
      [...list, ...rows].forEach(($list) => {
        if (!findeList.find((el) => el.id === list.id)) {
          findeList.push($list);
        }
      });
      setList(findeList);
    } else {
      setList(rows);
    }

  }, [rows]);
  // 滑动加载
  const loadMore = () => {
    if (hasMore) {
      setOffset(() => offset + 1);
      dispatch(setNoticeLoading(true));
    }
  };

  const getNoticeList = () => {
    if (access_token) {
      dispatch(getMsgLists({ schoolAppId: info?.id, offset, limit }));
    }
  };
  useEffect(() => {
    getNoticeList();
  }, [offset]);

  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [current, setCurrent] = useState({});

  const totalUnRead = rows.filter((item) => item.is_read === 'N').length;

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleMarkAllAsRead = () => {
    setNotifications(
      notifications.map((notification) => ({
        ...notification,
        isUnRead: false,
      }))
    );
  };

  // 处理点击信息
  const handleClickMsg = (item) => {
    setOpenModal(true);
    setCurrent(item);
    if (item.is_read === 'N') {
      updateMsgList({ id: item.id, action: 'read' })
        .then((res) => {
          console.log(res);
          dispatch(getMsgLists({ schoolAppId: info?.id, offset, limit }));;
        })
        .catch((err) => console.log(err));
    }
  };

  // 刷新数据
  const refreshData = () => {
    setList([]);
    setOffset(0);
  };

  return (
    <>
      <MIconButton
        ref={anchorRef}
        size="large"
        color={open ? 'primary' : 'default'}
        onClick={handleOpen}
      >
        <Badge
          badgeContent={
            totalUnRead > 0 && (
              <span
                style={{
                  backgroundColor: '#FF4848',
                  borderRadius: '50%',
                  padding: '3px',
                  color: 'white',
                  minWidth: '18px',
                  display: 'block',
                }}
              >
                {totalUnRead}
              </span>
            )
          }
          overlap="circular"
        >
          <Icon
            icon={bellFill}
            width={20}
            height={20}
            style={{ color: 'white' }}
          />
        </Badge>
      </MIconButton>

      <MenuPopover
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        sx={{ width: 360, borderRadius: '12px', overflow: 'hiddren' }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', py: 2, px: 2.5 }}>
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="subtitle1">{t('notice')}</Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              {t('notice_total', { totalUnRead })}
            </Typography>
          </Box>

          {totalUnRead > 0 && (
            <Tooltip title=" Mark all as read">
              <MIconButton color="primary" onClick={handleMarkAllAsRead}>
                <Icon icon={doneAllFill} width={20} height={20} />
              </MIconButton>
            </Tooltip>
          )}
        </Box>

        <Divider />

        <List disablePadding sx={{ maxHeight: '340px', overflowY: 'auto' }}>
          <InfiniteScroll
            initialLoad={false}
            pageStart={0}
            loader={
              <Box className="loader" key={0}>
                Loading ...
              </Box>
            }
            loadMore={loadMore}
            hasMore={hasMore}
            useWindow={false}
          >
            {list.map((item) => (
              <NotificationItem
                key={item.id}
                notification={item}
                refreshData={refreshData}
                onHandleClick={() => handleClickMsg(item)}
              />
            ))}
          </InfiniteScroll>
        </List>
        <Divider />
      </MenuPopover>

      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {current.title}
          </Typography>
          <Typography
            id="modal-modal-description"
            className="ql-editor"
            dangerouslySetInnerHTML={{ __html: current.content }}
            sx={{ mt: 2 }}
          />
        </Box>
      </Modal>
    </>
  );
}
